/* eslint-disable better-mutation/no-mutation */
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

type MyTraderaNextJsState = {
    changeShippingModalData?: {
        purchaseOrderId: string;
        receiverCountry: string;
        isChangeShippingModalOpen: boolean;
    };
    cancelShippingModalData?: {
        purchaseOrderId: string;
        shippingId: string;
        isCancelShippingModalOpen: boolean;
    };
    shippingQrCodeModalData?: {
        purchaseOrderId: string;
        isShippingQrCodeModalOpen: boolean;
    };
};

const mySoldSlice = createSlice({
    name: 'mySold',
    initialState: {} as MyTraderaNextJsState,
    reducers: {
        openChangeShipping: (
            state,
            action: PayloadAction<{
                purchaseOrderId: string;
                receiverCountry: string;
            }>,
        ) => {
            state.changeShippingModalData = {
                ...action.payload,
                isChangeShippingModalOpen: !!action.payload.purchaseOrderId,
            };
        },
        closeChangeShipping: (state) => {
            state.changeShippingModalData = undefined;
        },
        openCancelShipping: (
            state,
            action: PayloadAction<{
                purchaseOrderId: string;
                shippingId: string;
            }>,
        ) => {
            state.cancelShippingModalData = {
                ...action.payload,
                isCancelShippingModalOpen: true,
            };
        },
        closeCancelShipping: (state) => {
            state.cancelShippingModalData = undefined;
        },
        openShippingQrCode: (
            state,
            action: PayloadAction<{ purchaseOrderId: string }>,
        ) => {
            state.shippingQrCodeModalData = {
                ...action.payload,
                isShippingQrCodeModalOpen: true,
            };
        },
        closeShippingQrCode: (state) => {
            state.shippingQrCodeModalData = undefined;
        },
    },
});
export const {
    openChangeShipping,
    closeChangeShipping,
    openCancelShipping,
    closeCancelShipping,
    openShippingQrCode,
    closeShippingQrCode,
} = mySoldSlice.actions;
export default mySoldSlice.reducer;
